import * as React from 'react';
import { cn } from '../utils/cn';

export interface LogoProps extends React.SVGAttributes<SVGSVGElement> {
  withWordmark?: boolean;
  brandName?: string;
}

/**
 * Lectura logó — nyitott könyv + lila gradiens.
 * Saját készítésű, nem utánoz külső márkát.
 */
export function Logo({ withWordmark = true, brandName = 'Lectura', className, ...props }: LogoProps) {
  return (
    <span className={cn('inline-flex items-center gap-2', className)}>
      <svg
        viewBox="0 0 40 40"
        width="32"
        height="32"
        role="img"
        aria-label={brandName}
        {...props}
      >
        <defs>
          <linearGradient id="lectura-mark" x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#7339f0" />
            <stop offset="100%" stopColor="#c2418a" />
          </linearGradient>
        </defs>
        <rect x="2" y="2" width="36" height="36" rx="10" fill="url(#lectura-mark)" />
        <path
          d="M11 12.5c2.6-1.6 6-1.8 9 .2v15.6c-3-2-6.4-1.8-9-.2V12.5Zm9 .2c3-2 6.4-1.8 9-.2v15.6c-2.6-1.6-6-1.8-9 .2V12.7Z"
          fill="white"
          opacity="0.96"
        />
      </svg>
      {withWordmark ? (
        <span className="font-display text-lg font-bold tracking-tight">{brandName}</span>
      ) : null}
    </span>
  );
}
